import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/noroloji-doktorlari-neden-botoks-onermez/page.tsx");
